import ReactOnRails from 'react-on-rails';
import SpotDetail from '../../bundles/SpotDetail/components/SpotDetail.client.jsx';

ReactOnRails.register({SpotDetail});
